import React, {useEffect} from "react"
import CommonUtils from "../../base/utils/CommonUtils";
import {Box, ListItem, Paper, Tooltip} from "@mui/material";
import Api, {APIs} from "../../../Api";



const NewsFeed = () => {
    const paperHeight = CommonUtils.getPaperHeight(0, 10)
    const [news, setNews] = React.useState<any[]>([])
    useEffect(()=>{
        Api.get(APIs.EAD_NEWS_FEED).then((payload) => {
            if (payload) {
                // setNews(payload)

            }
        })
    }, [])

    return (
        <Box style={{boxSizing: "border-box"}} sx={{
            display: 'flex', flexDirection: 'column',
            backgroundColor:"#454545"
        }}>
            <Paper elevation={6} style={{padding: "30px", height: paperHeight, overflow: "auto"}}>
                <Box sx={{display: 'list-items', paddingTop: 2, paddingBottom: 2}}>
                    {news.length === 0 ?
                        <ListItem sx={{
                            display: 'list-item',
                            fontSize: 14,
                            fontWeight: 3,
                            padding: 2, margin: 0
                        }}>No News Feed</ListItem> :
                        news.map((n) => <ListItem sx={{
                            display: 'list-item',
                            fontSize: 14,
                            fontWeight: 3,
                            padding: 2, margin: 0
                        }}>
                            <span style={{fontWeight: "bold"}}>{n.user}</span> has
                            changed <Tooltip title={String(n.fields)}>
                            <Box component={"span"} sx={{color: "red"}}>
                                {n.project}
                            </Box>
                        </Tooltip> data on <span style={{color: "blue"}}>{n.date}</span>
                        </ListItem>)
                    }
                </Box>
            </Paper>
        </Box>
    )
}

export default NewsFeed
